import React from "react";
import { ArrowRight, MoveRight, Sparkles } from "lucide-react";
import { useCMS, useSectionEnabled } from "../context/CMSContext";

export default function Migration() {
  const enabled = useSectionEnabled("migration");
  const { cms } = useCMS();
  if (!enabled) return null;
  const m = cms?.migration || {};

  return (
    <section className="bg-[#FFFBF6] py-16 sm:py-20">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        <div className="lm-dark-card overflow-hidden p-7 sm:p-10 lg:p-14 relative">
          <div className="absolute -top-20 -right-20 w-80 h-80 rounded-full bg-[#FF6B3D]/15 blur-3xl" />
          <div className="absolute -bottom-24 -left-24 w-80 h-80 rounded-full bg-[#FF6B3D]/10 blur-3xl" />

          <div className="relative grid lg:grid-cols-2 gap-8 lg:gap-10 items-center">
            <div>
              <span className="lm-chip-accent inline-flex items-center gap-1 px-3 py-1 rounded-full text-xs font-bold uppercase tracking-wider">
                <Sparkles className="w-3.5 h-3.5" /> Free Migration
              </span>
              <h2 className="lm-font font-extrabold text-white text-2xl sm:text-4xl lg:text-5xl mt-4 leading-tight">
                {m.title}
              </h2>
              <p className="text-white/70 mt-4 sm:mt-5 text-base sm:text-lg leading-relaxed">{m.description}</p>
              <a
                href={m.ctaUrl || "#pricing"}
                className="lm-btn-accent mt-6 sm:mt-7 inline-flex items-center gap-2 px-5 py-3 rounded-xl font-bold text-sm"
              >
                {m.ctaText || "Start Migration"} <ArrowRight className="w-4 h-4" />
              </a>
            </div>

            <div className="grid gap-3 sm:gap-4">
              {(m.steps || []).map((step, idx) => (
                <div key={step.title} className="bg-white/5 border border-white/10 rounded-2xl p-4 sm:p-5 backdrop-blur-sm flex gap-3 sm:gap-4">
                  <span className="w-10 h-10 sm:w-11 sm:h-11 rounded-xl bg-[#FF6B3D] flex items-center justify-center flex-shrink-0">
                    <span className="lm-font font-extrabold text-[#11151C]">{idx + 1}</span>
                  </span>
                  <div>
                    <h4 className="lm-font font-bold text-white text-base sm:text-lg flex items-center gap-2">
                      {step.title}
                      <MoveRight className="w-4 h-4 text-[#FF6B3D]" />
                    </h4>
                    <p className="text-white/70 text-sm mt-1 leading-relaxed">{step.desc}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
